import { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { selectIsLoading } from 'state/quote/quote-slice';
import { PRODUCTS_PER_ROW } from 'config/app-config';

export const useTariffList = ({ products }) => {
  const multiRowProducts = products?.length > PRODUCTS_PER_ROW;
  const [showMore, setShowMore] = useState(multiRowProducts);

  const displayedProducts = !showMore
    ? products
    : products?.slice(0, PRODUCTS_PER_ROW);
  const isLoadingTariff = useSelector(selectIsLoading, shallowEqual);

  return {
    showMore,
    setShowMore,
    displayedProducts,
    isLoadingTariff,
    multiRowProducts
  };
};
